// extracted by mini-css-extract-plugin
module.exports = {"content-container":"content-section_content-container__uZKWJ","title-section":"content-section_title-section__MFGda","action-button":"content-section_action-button__NaPLX"};